import React, { useState } from 'react';
import FilterTemplate from '../components/filtertemplate/FilterTemplate';
import { CalendarIcon, UserIcon, SwapIcon, CloseIcon } from '../components/shared/Icons';
import CustomSelect from '../components/shared/CustomSelect';
import HelpButton from '../components/shared/HelpButton';
import { useUser } from '../utils/UserContext';
import { fetchExtrawork, handleExtraworkSubmit, downloadExtrawork } from '../utils/api';
import { rolesAccess } from '../data/map';
import { cssUrl } from '../utils/cssVersion';
import FilterChips from '../components/shared/FilterChips';
import { CHIP_GROUP_COLORS } from '../components/shared/chipColors';
const filterStyles = cssUrl('filterTemplate.css');
const displayDate = (isoDate) => {
  if (!isoDate) return '';
  const [year, month, day] = isoDate.split('-');
  return `${day}/${month}/${year}`;
};


const ExtraworkCard = ({ item, onClick, isAdmin }) => {
  const selectedWeekend = item[4] === 'Sat' || item[4] === 'Sun' ? '1' : '0';
  const selectedDay = item[4] !== 'Sat' && item[4] !== 'Sun' ? '1' : '0';

  return (
    <div className="fr-card" onClick={() => onClick(item)}>
      <div className="fr-card-header">
        <div className="fr-card-dates">
          <CalendarIcon />
          <span className="fr-card-date-start">{displayDate(item[1])}</span>
          <span className="fr-card-date-sep">→</span>
          <span className="fr-card-date-end">{displayDate(item[1])}</span>
        </div>
        <div className="fr-card-status-badge-extra" data-status={item[5]?.toLowerCase()}>
          {item[5]}
        </div>
      </div>

      <div className="fr-card-body">
        <div className="fr-card-row">
          <UserIcon />
          <span className="fr-card-label">Cleaner:</span>
          <span className="fr-card-value">{item[3]}</span>
          <span className="fr-card-status-tag" data-status={item[8]?.toLowerCase()}>
            Time : {item[8]} {parseFloat(item[8]) > 1 ? 'hrs' : 'hr'}
          </span>
        </div>

        <div className="fr-card-row">
          <SwapIcon />
          <span className="fr-card-label">Site:</span>
          <span className="fr-card-value">{item[2]}</span>
          <span className="fr-card-status-tag" data-status={item[7]?.toLowerCase()}>
            Charge : {item[7]}
          </span>
        </div>

        <div className="fr-card-row">
          <UserIcon />
          <span className="fr-card-label">Approved by:</span>
          <span className="fr-card-value">{item[6]}</span>
          <span className="fr-card-status-tag" data-status={item[4]?.toLowerCase()}>
            Day : {item[4]}
          </span>
        </div>
      </div>

      <div className="fr-card-footer">
       
        <div className="fr-card-meta">
          <span className="fr-card-meta-item fr-card-middle">
          <CalendarIcon />
            Weekdays: {selectedDay} &nbsp; Weekend: {selectedWeekend}</span>
        </div>
        
      </div>

      <div className="fr-card-tap-hint">Tap to update extrawork</div>
    </div>
  );
};


const UpdateTimeModal = ({ item, onClose, onSubmit, isSubmitting, onToast, isAdmin, user }) => {
  
  const [timeValue, setTimeValue] = useState(item?.[8]?.toString() || '');
  const [dayValue, setDayValue] = useState(item?.[4]?.toString() || '');
  const [dateValue, setDateValue] = useState(item?.[1] || '');
  const days = ['Mon', 'Tues', 'Wed', 'Thur', 'Fri', 'Sat', 'Sun'];
  

 

  const extraworkDates = (data, dateValue) => {
  const today = new Date();
  const request = new Date(dateValue);
  const requestMonth = request.getMonth();
  const currentMonth = today.getMonth();
  
  
  if (requestMonth < currentMonth) {
    onToast({ message: "Request date can't be in a prior month.", type: 'warning' });
    return false;
  }



  return true;
};

const toNumberString = (val) => {
    if (val === null || val === undefined || val === '') return '';
    const cleaned = String(val).replace(/[$,\s]/g, '');
    if (cleaned === '' || cleaned === '-') return '';
    const num = parseFloat(cleaned);
    return isNaN(num) ? '' : String(num);
  };

  const handleSubmit = () => {
    if (!extraworkDates(item,dateValue)){ return };
    onSubmit({
      recordId: item[0],
      workdate: dateValue,
      dayworked: dayValue,
      timeworked: toNumberString(timeValue) || "0",
    });
  };

  return (
    <div className="fr-modal-overlay" onClick={onClose}>
      <div className="fr-modal" onClick={(e) => e.stopPropagation()}>
        <div className="fr-modal-handle" />
        <div className="fr-modal-header">
          <h3 className="fr-modal-title">Update Extra Work</h3>
          <button className="fr-modal-close" onClick={onClose}>
            <CloseIcon />
          </button>
        </div>

        <div className="fr-modal-body">
          <div className="fr-modal-field">
            <label className="fr-modal-label">Cleaner</label>
            <div className="fr-modal-value">{item[3]}</div>
          </div>
          <div className="fr-modal-field">
            <label className="fr-modal-label">Site</label>
            <div className="fr-modal-value">{item[2]}</div>
          </div>
        {isAdmin && (
          <>
            <div className="fr-modal-field">
              <label className="fr-modal-label">Select dateworked</label>
              <input
                type="date"
                className="fr-modal-input"
                value={dateValue}
                onChange={(e) => setDateValue(e.target.value)}
              />
            </div>
            <CustomSelect
              label="Day of Week"
              value={dayValue}
              onChange={setDayValue}
              options={days}
            />
          </>
        )}

            <div className="fr-modal-field">
              <label className="fr-modal-label">Time Updated</label>
              <input
                type="number"
                step="0.25"
                min="0"
                className="fr-modal-input"
                value={timeValue}
                onChange={(e) => {
                    const v = e.target.value;
                    if (v === '' || Number(v) >= 0) setTimeValue(v);
                  }}
                
                placeholder="Enter hours"
              />
            </div>
        </div>

        <div className="fr-modal-actions">
          <button className="fr-modal-btn fr-btn-cancel" onClick={onClose}>
            Close
          </button>
          <button
            className="fr-modal-btn fr-btn-submit"
            onClick={handleSubmit}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Processing...' : 'Process Extrawork'}
          </button>
        </div>
      </div>
    </div>
  );
};


const filterChipGroups = [
  {
    color: CHIP_GROUP_COLORS.cyan,
    values: ['Simon', 'Lauro', 'Tayde Susana', 'Sandra Julieth',
  'Danielle','Laura Sofia','Caroline','Md Mahamudul','Miguel Angel','Tomas'],
  },
  
];
const FilterExtrawork = ({ showHeader = false }) => {

  const { user } = useUser();
  const isAdmin = rolesAccess.admin.includes(user?.userJob || '');
  const isManagement = rolesAccess.management.includes(user?.userJob || '');

  return (
  <FilterTemplate
    title="Extra Work"
    helpButton={
    <HelpButton helpData={[
      { chip: 'extrawork_filter', urlFilter: '/static/pdffilters/ExtraworkFilter.pdf' }
      ]} />
  }
    
    subtitle="Extra Work"
    searchPlaceholder="Search by date, site, or name..."
    stylesheetHref={filterStyles}
    fetchData={fetchExtrawork}
    dataKey="extrawork"
    searchFields={[1, 2, 3, 4, 5, 6, 7]}
    onSubmit={handleExtraworkSubmit}
    loadingMessage="Loading extra work..."
    showNavigation={true}
    chipLogic="or"
    onDownload={(isAdmin || isManagement) && downloadExtrawork}
    showHeader={showHeader}
    renderChips={(chipQuery, setChipQuery, chipsOpen, setChipsOpen) => (
        <FilterChips
          chipGroups={filterChipGroups}
          chipQuery={chipQuery}
          setChipQuery={setChipQuery}
          chipsOpen={chipsOpen}
          setChipsOpen={setChipsOpen}
        />
      )}
    renderCard={(item, onClick) => (
      <ExtraworkCard item={item} onClick={onClick} isAdmin={isAdmin}/>
    )}
    renderModal={(item, onClose, onSubmit, isSubmitting, setToast) => (
      <UpdateTimeModal
        item={item}
        onClose={onClose}
        onSubmit={onSubmit}
        isSubmitting={isSubmitting}
        onToast={setToast}
        isAdmin={isAdmin}
        user={user}
      />
    )}
  />
);
};

export default FilterExtrawork;